import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import PlaceLookup from 'components/PlaceLookup';

const useStyles = makeStyles((theme) => ({
  content: {
    padding: 20,
  },
  btnWrap: {
    marginBottom: theme.spacing(1),
    '& button': {
      marginRight: theme.spacing(1),
    },
  },
}));

let timeout = 0;

const defaultPlace2 = {
  PlaceORI: '3232023',
  PlaceName: 'NIBRS Police Department',
  PlaceType: 'LAW',
  Flags: null,
  IsDeleted: false,
  Deleted: null,
  DeletedBy: null,
  Created: '2024-01-05T07:41:16.890Z',
  DeletedIP: null,
  CreatedBy: 'SPARRIE',
  Updated: '2025-01-27T20:01:45.653Z',
  UpdatedBy: 'GRZEGORZ',
  UpdatedIP: '127.0.0.1      ',
  ROWGUID: '12642B28-B9B8-474E-BA9E-1028D05F2184',
  ptsPlaceID: 3665,
  PlaceID: 'PLC0000000222',
  AddressCategory: null,
  BldgType: null,
  BldgIdentifier: null,
  FloorType: null,
  FloorIdentifier: null,
  UnitType: 'Room',
  UnitIdentifier: null,
  POBox: null,
  AddressNumberPrefix: null,
  AddressNumber: 111,
  AddressNumberSuffix: null,
  StreetName: 'test',
  PreDirection: 'P',
  PostDirection: 'NE',
  StreetType: 'BLVD',
  County: null,
  ptsCityID: 2,
  State: 'DC',
  Country: null,
  PostalCode: null,
  PostalCodeExtension: null,
  ESN: null,
  ShowAlert: false,
  SexOffender: false,
  Parolee: false,
  Probation: false,
  NonValidatedAddress: false,
  CLERYLocationType: 0,
  FullAddressText: ' 111 P test BLVD NE, Room Benton, DC',
  Notes: null,
  ptsCoordinateID: null,
  ptsAddressID: 10132,
  AddressID: 'ADR0000000570',
  Locale: null,
  SurroundingArea: null,
  Description: null,
  Area: null,
  CrossStreet: null,
  Highway: null,
  LandmarkText: null,
  MapLocation: null,
  RangeDescription: null,
  RelativeLocation: null,
  AltitudeMeasure: null,
  DepthMeasure: null,
  GeographicElevation: null,
  MGRSCoordinate: null,
  TwoDGeographicCoordinate: null,
  UTMCoordinate: null,
  IsDestination: true,
  PlaceDepartmentID: null,
  IsPrimary: false,
};

const defaultPlace3 = {
  PlaceORI: 'FIREORI',
  PlaceName: 'Fire Department Place',
  PlaceType: 'FIRE',
  Flags: null,
  IsDeleted: false,
  Deleted: null,
  DeletedBy: null,
  Created: '2020-06-27T01:19:02.030Z',
  DeletedIP: null,
  CreatedBy: 'BARTEK',
  Updated: '2024-02-28T13:16:05.263Z',
  UpdatedBy: 'MMCNEIL',
  UpdatedIP: '127.0.0.1      ',
  ROWGUID: 'CA21EC9C-A956-4979-BF6B-ECCC1194BF49',
  ptsPlaceID: 2,
  PlaceID: 'PLC0000000002',
  AddressCategory: 'Residence',
  BldgType: null,
  BldgIdentifier: '',
  FloorType: null,
  FloorIdentifier: '',
  UnitType: null,
  UnitIdentifier: '',
  POBox: null,
  AddressNumberPrefix: null,
  AddressNumber: 316,
  AddressNumberSuffix: null,
  StreetName: 'Conway',
  PreDirection: 'W',
  PostDirection: null,
  StreetType: 'ST',
  County: null,
  ptsCityID: 2,
  State: 'AR',
  Country: null,
  PostalCode: '72015',
  PostalCodeExtension: null,
  ESN: null,
  ShowAlert: false,
  SexOffender: false,
  Parolee: false,
  Probation: false,
  NonValidatedAddress: false,
  CLERYLocationType: 0,
  FullAddressText: '316 W Conway ST, Benton, AR 72015',
  Notes: 'This is a test of address notes field. Address notes would show here.',
  ptsCoordinateID: 3893,
  ptsAddressID: 10283,
  AddressID: 'ADR0000000743',
  Locale: null,
  SurroundingArea: '',
  Description: '',
  Area: 'FIREDIST1',
  CrossStreet: '',
  Highway: '',
  LandmarkText: '',
  MapLocation: '',
  RangeDescription: '',
  RelativeLocation: '',
  AltitudeMeasure: '',
  DepthMeasure: '',
  GeographicElevation: '',
  MGRSCoordinate: '',
  TwoDGeographicCoordinate: '',
  UTMCoordinate: '',
  IsDestination: false,
  PlaceDepartmentID: 'FIREPLACE',
  IsPrimary: false,
};

const defaultPlaces2 = [
  {
    ptsPlaceID: 5,
    PlaceID: 'PLC0000006673',
    PlaceName: 'Extra super place',
    PlaceType: 'EMP',
    PlaceORI: '',
    PlaceDepartmentID: null,
    IsDestination: false,
    FullAddressText: null,
    ptsAddressID: null,
  },
  {
    ptsPlaceID: 2,
    PlaceID: 'PLC0000000002',
    PlaceName: 'Fire Department Place',
    PlaceType: 'FIRE',
    PlaceORI: 'FIREORI',
    PlaceDepartmentID: 'FIREPLACE',
    IsDestination: false,
    FullAddressText: '23 Jackson Street ST Columbus 23456 5743',
    ptsAddressID: 9162,
  },
  {
    ptsPlaceID: 3,
    PlaceID: 'PLC0000000003',
    PlaceName: 'Place name',
    PlaceType: null,
    PlaceORI: null,
    PlaceDepartmentID: null,
    IsDestination: false,
    FullAddressText: null,
    ptsAddressID: null,
  },
];

function PlacesTesting() {
  const classes = useStyles();
  const [place1, setPlace1] = useState(null);
  const [place2, setPlace2] = useState(defaultPlace2);
  const [place3, setPlace3] = useState(null);
  const [places1, setPlaces1] = useState([]);
  const [places2, setPlaces2] = useState(defaultPlaces2);
  const [places3, setPlaces3] = useState([]);

  useEffect(() => {
    timeout = setTimeout(() => {
      setPlace3(defaultPlace3);
      setPlaces3(defaultPlaces2);
    }, 2000);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const consolePlaces = () => {
    console.log('place1:', place1);
    console.log('place2:', place2);
    console.log('place3:', place3);
    console.log('places1:', places1);
    console.log('places2:', places2);
    console.log('places3:', places3);
  };

  return (
    <div className={classes.content}>
      <div className={classes.btnWrap}>
        <h1>Places Testing</h1>
        <h5>Place without default value</h5>
        <PlaceLookup label="Place 1" value={place1} onChange={setPlace1} />
        <br />
        <h5>Place with default value</h5>
        <PlaceLookup
          label="Place 2"
          value={place2}
          onChange={setPlace2}
          ptsPlaceID={place2?.ptsPlaceID}
        />
        <br />
        <h5>Place with default value that has been updated after 2 sec</h5>
        <PlaceLookup
          label="Place 3"
          value={place3}
          onChange={setPlace3}
          ptsPlaceID={place3?.ptsPlaceID}
        />
        <br />
        <h5>Multiple places without default value</h5>
        <PlaceLookup label="Place" value={places1} onChange={setPlaces1} multiple={true} />
        <br />
        <h5>Multiple places with default value</h5>
        <PlaceLookup
          label="Place"
          value={places2}
          onChange={setPlaces2}
          multiple={true}
          ptsPlaceID={places2.map((p) => p.ptsPlaceID)}
        />
        <br />
        <h5>Multiple places with default value that has been updated after 2 sec</h5>
        <PlaceLookup
          label="Place"
          value={places3}
          onChange={setPlaces3}
          multiple={true}
          ptsPlaceID={places3.map((p) => p.ptsPlaceID)}
        />
        <br />
        <Button variant="contained" color="primary" onClick={consolePlaces}>
          Console places
        </Button>
      </div>
    </div>
  );
}

export default PlacesTesting;
